import { useCollectionData } from "react-firebase-hooks/firestore";
import { collection, doc, query } from "firebase/firestore";
import { db } from "@poseidon/firebase";
import { where } from "firebase/firestore";
import { withIdConverter } from "@poseidon/firebase/converters/with-id";

export function useSailorAgreements(sailorId) {
  const [sailorAgreements, loading, error] = useCollectionData(
    query(
      collection(db, "agreements"),
      where("sailors", "array-contains", doc(db, "sailors", sailorId))
    ).withConverter(withIdConverter)
  );
  return { sailorAgreements, loading, error };
}
